<template>
  <div class="container">
    <h1>Rastreabilidade logística - Lotes</h1>

    <div class="wrapper">
      <div class="filter">
        <form @submit.prevent="handleSubmit">
          <select-default
            v-if="ntoInputReady"
            :data-list="ntoDataList"
            :initial-value="ntoInitialValue"
            @valueSelected="getValueNto"
          />

          <select-default
            v-if="statusInputReady"
            :data-list="statusDataList"
            :initial-value="statusInitialValue"
            @valueSelected="getValueStatus"
          />

          <date-picker-range
            :date-selected.sync="date"
            :clear-button="false"
            calendar-direction="bottom"
            date-filter-alternative
          />

          <input
            v-model="loteEspecifico"
            placeholder="Buscar por lote específico"
            class="input-search"
          />

          <md-button
            class="btn btn-primary"
            type="submit"
          >
            Consultar
          </md-button>
        </form>
      </div>

      <loading v-if="isLoading" />
      <div
        class="wrapper-content"
        v-else
      >
        <div>
          <div class="card-main">
            <p class="card-title">{{ ntoData.destination }}</p>
            <p class="card-subtitle">
              Atualizado há
              <span>{{ updatedAtInMinutes }} min</span>
            </p>

            <div class="card-content">
              <p>Total de lotes encontrados</p>
              <p class="card-value">{{ ntoData.totalLots }}</p>
            </div>
          </div>

          <traceability-card
            v-for="batch in ntoData.lotLogisticList"
            :key="batch.lotId"
            :batch="batch"
            :active="selectedBatch && selectedBatch.lotId === batch.lotId"
            @select-batch="onSelectBatch"
          />
        </div>

        <traceability-wrapper-map
          :batch="selectedBatch"
          :nto-name="ntoData.destination"
          :updated-at="updatedAtInMinutes"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '@/components/common/DatePickerRange'
import SelectDefault from '@/components/common/SelectDefault.vue'
import TraceabilityCard from '@/components/TraceabilityLogisticBatches/components/TraceabilityCard.vue'
import TraceabilityWrapperMap from '@/components/TraceabilityLogisticBatches/components/TraceabilityWrapperMap.vue'
import Spinner from '@/components/common/Spinner'
import Moment from 'moment'
import { getNtoList } from '@/api/traceability'
import ServiceBatch from '@/api/batch'

export default {
  name: 'TraceabilityLogisticBatches',
  components: {
    'select-default': SelectDefault,
    'traceability-card': TraceabilityCard,
    'traceability-wrapper-map': TraceabilityWrapperMap,
    DatePickerRange,
    loading: Spinner,
  },
  data() {
    return {
      selectedNTO: null,
      selectedStatus: null,
      loteEspecifico: '',
      selectedBatch: null,
      ntoInitialValue: null,
      statusInitialValue: null,
      areInitialValuesSet: false,
      updatedAtInMinutes: 0,
      ntoDataList: {
        id: 'selectNTO',
        placeholder: 'Selecione o NTO',
        options: [],
      },
      ntoData: {
        ntoName: '',
        totalBatchesInNto: 0,
      },
      isLoading: true,
      date: {
        start: Moment(new Date()).subtract(7, 'days'),
        end: new Date(),
      },
    }
  },
  computed: {
    ntoInputReady() {
      return this.areInitialValuesSet
    },
    statusOptions() {
      return [
        { value: '', text: 'Selecione o Status' },
        { value: 'AMOSTRA_OBTIDA', text: 'Aguardando retirada' },
        { value: 'EM_TRANSITO', text: 'Em trânsito' },
        { value: 'EM_TRANSITO_ENTRE_NTO', text: 'Em trânsito entre NTO' },
      ]
    },
    statusInputReady() {
      return this.areInitialValuesSet
    },
    statusDataList() {
      return {
        id: 'selectStatus',
        placeholder: 'Selecione o Status',
        options: this.statusOptions,
      }
    },
  },
  mounted() {
    setInterval(() => {
      this.updatedAtInMinutes = this.updatedAtInMinutes + 1
    }, 60000)

    this.getNtoList()
  },
  methods: {
    getValueNto(value) {
      this.selectedNTO = value
    },
    getValueStatus(value) {
      this.selectedStatus = value
    },
    async getNtoList() {
      try {
        const response = await getNtoList()
        this.ntoDataList = {
          id: 'selectNTO',
          placeholder: 'Selecione o NTO',
          options: response.data.map(item => ({
            value: item.idDestination,
            text: item.destination,
          })),
        }

        this.setInitialValues()
      } catch (error) {
        console.error('Error fetching NTO list:', error)
      }
    },
    async getBatchs(idDestination) {
      const params = {}
      if (this.selectedNTO?.value || idDestination) {
        params.destinationId = this.selectedNTO?.value || idDestination
      }

      if (this.selectedStatus?.value) {
        params.status = this.selectedStatus.value
      }

      if (this.loteEspecifico?.trim()) {
        params.batchCode = this.loteEspecifico.trim()
      }

      if(this.date.start && this.date.end){
        params.startDate = this.date.start;
        params.endDate = this.date.end;
      }

      try {
        const { data } = await ServiceBatch.getBatchByDestinationId(params)

        this.ntoData = data
      } catch (error) {
        console.error('Erro ao buscar lotes:', error)
      } finally {
        this.isLoading = false
      }
    },
    handleSubmit() {
      this.selectedBatch = null
      this.isLoading = true
      this.getBatchs()
    },
    async onSelectBatch(batch) {
      const { data } = await ServiceBatch.getBatchDetailsByLotId(batch.lotId)

      this.selectedBatch = data

      this.$emit('batch-selected', data)
    },
    setInitialValues() {
      const destinationId = this.$route.query.destinationId

      if (destinationId) {
        this.getBatchs(destinationId)
        const option = this.ntoDataList.options.find(
          option => option.value === destinationId
        )

        if (option) {
          this.ntoInitialValue = option
        }
      }

      const status = this.$route.query.status

      if (status) {
        const option = this.statusOptions.find(option => option.value === status)

        if (option) {
          this.statusInitialValue = option
        }
      }

      this.areInitialValuesSet = true
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  font-family: 'Exo 2', sans-serif;

  .wrapper {
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: flex-start;

    &-content {
      display: flex;
      gap: 20px;
      width: 100%;
    }
  }

  .card-main {
    width: 290px;
    height: 114px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 1rem;

    .card-title {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: #818181;
      margin: 0;
    }

    .card-subtitle {
      color: #999999;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 8px;

      span {
        font-weight: 600;
      }
    }

    .card-content {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 13px;
      line-height: 20px;
      color: #818181;
      margin: 0;
      text-transform: uppercase;

      .card-value {
        font-size: 23.04px;
        font-weight: 700;
        color: #7f1a54;
      }
    }
  }

  h1 {
    color: #818181;
    font-size: 34px;
  }

  .filter {
    margin-top: 2rem;
    display: flex;
    gap: 10px;
    background: #ffffff;
    padding: 8px;
    border-radius: 8px;
    width: 100%;

    form {
      display: flex;
      gap: 10px;
      width: 100%;
      flex-wrap: wrap;

      button {
        height: 40px;
        font-weight: 600;
      }
    }

    .input-search {
      flex: 1;
      padding: 0 10px;
      border: 1px solid #c4c4c4;
      border-radius: 4px;
      font-size: 16px;
      color: #818181;
      height: 40px;

      &::placeholder {
        color: #c4c4c4;
      }

      &:focus {
        outline: none;
        border-color: #818181;
      }
    }
  }

  .search-bar__date {
    flex: inherit !important;
    padding: 0 8px;
    border-radius: 3px;
    border: 1px solid #CCCCCC;
    
    .md-input-container {
      padding: 0;
      margin: 0;
    }
  }
}
</style>
<style lang="scss">
.wrapper .filter {
  .alternative .md-input-container {
    margin: 0;
    padding: 3px 0;
    height: 38px;
    min-height: inherit !important;

    input {
      font-weight: 500;
      font-size: 13px;
    }

    i {
      margin: 4px 4px 4px 8px;
    }
  }
}

</style>
